import request from '@/utils/request'

let LogisticsApi = {

  /*添加物流中心*/
  addLogistics(data) {
    return request._post('/shop/plus.logistics.lists/addLogistics', data);
  },
  /*编辑物流中心*/
  editLogistics(data) {
    return request._post('/shop/plus.logistics.lists/editLogistics', data);
  },

  /* 物流中心列表 */
  logisticsList(data){
    return request._post('/shop/plus.logistics.lists/index',data);
  },
  /* 区域城市 */
  detail(data){
    return request._get('/shop/plus.logistics.lists/detail',data);
  },
  /* 区域城市 */
  addPrepare(data){
    return request._get('/shop/plus.logistics.lists/addPrepare',data);
  },
  /* 删除区域中心 */
  deleteLogistics(data){
    return request._post('/shop/plus.logistics.lists/delete',data);
  },
  /* 获取物流中心设置 */
  settingDetail(data){
    return request._get('/shop/plus.logistics.setting/index',data);
  },
  editSetting(data){
    return request._post('/shop/plus.logistics.setting/index',data);
  },
  accountList(data){
    return request._post('/shop/plus.logistics.manager/index',data);
  },
  addAccount(data){
    return request._post('/shop/plus.logistics.manager/add',data);
  },
  deleteAccount(data){
    return request._post('/shop/plus.logistics.manager/delete',data);
  },
  productList(data){
    return request._post('/shop/plus.logistics.manager/lists',data);
  },
  updateLogisticsStock (data){

    return request._post('/shop/plus.logistics.manager/updateLogisticsStock',data);

  }
}

export default LogisticsApi;



// WEBPACK FOOTER //
// ./src/api/logistics.js